// extracted by mini-css-extract-plugin
export var selectedManager = "selected-manager_GPkSxja1x4tJd2L6uYK3";
export var selectedManagerEmail = "selected-manager__email_cwfQ35yHWt3UNJYp5Hyg";
export var selectedManagerName = "selected-manager__name_ohzxlImX5WgJfBeh9mvv";